// @ts-check

import definitions from "../definitions/jupiter.json";

export function loadDefinitions() {
	return Promise.resolve(definitions);
}
